function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

/**
 * Ensures a URL path is lowercase
 * @param {string} path - The URL path to convert to lowercase
 * @returns {string} The lowercase URL path
 */
export function toLowerCasePath(path) {
    return path.toLowerCase();
}

/**
 * Converts a title to a URL-friendly slug by removing apostrophes
 * @param {string} title - The title to convert to a slug
 * @returns {string} The URL-friendly slug with apostrophes removed
 */
export function titleToSlug(title) {
    if (!title) return '';
    
    // First remove apostrophes completely
    let slug = title.toLowerCase().replace(/'/g, '');
    
    // Then replace other special characters with hyphens
    slug = slug.replace(/[^a-z0-9]+/g, '-');
    
    // Remove leading and trailing hyphens
    slug = slug.replace(/^-+|-+$/g, '');
    
    return slug;
}

/**
 * Converts a title to a URL-friendly slug by removing apostrophes
 * This matches our desired format for URLs
 * @param {string} title - The title to convert to a slug
 * @returns {string} The URL-friendly slug with apostrophes removed
 */
export function createHyphenatedSlug(title) {
    if (!title) return '';
    
    // Remove apostrophes completely (not replace with hyphens)
    let slug = title.toLowerCase().replace(/'/g, '');
    
    // Replace other special characters with hyphens
    slug = slug.replace(/[^a-z0-9]+/g, '-');
    
    // Remove duplicate hyphens
    slug = slug.replace(/-+/g, '-');
    
    // Remove leading and trailing hyphens
    slug = slug.replace(/^-+|-+$/g, '');
    
    return slug;
}

/**
 * Converts a slug back to a title-like format
 * @param {string} slug - The slug to convert back to title format
 * @returns {string} The title-like format
 */
export function slugToTitle(slug) {
    if (!slug) return '';
    
    return slug
        .replace(/-/g, ' ')      // Replace hyphens with spaces
        .replace(/\b\w/g, l => l.toUpperCase()); // Capitalize first letter of each word
}

export { clamp }